export default "__VITE_ASSET__CAHB1ZP4__"